let prefixed = name => 'sourcing-workflow/service-request/' + name

export const isTeamLeader = prefixed('isTeamLeader')
export const isTeamMember = prefixed('isTeamMember')
export const isVendor = prefixed('isVendor')
export const roleName = prefixed('roleName')
export const redmineUser = prefixed('redmineUser')

export const project = prefixed('project')

export const initialize = prefixed('initialize')



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/store/definition.js